import axios from 'axios';
import ReduxStoreStore from 'stores/ReduxStoreStore';
import CsrfTokenActions from './CsrfTokenActions';
import { setCsrfToken } from './shared';

const startDataTag = '<script type="application/json" id="__data__">';
const endDataTag = '</script>';

class CsrfTokenActionCreator {
  refreshToken() {
    return axios.get('/').then(({ data }) => {
      const dataStart = data.substring(data.indexOf(startDataTag));
      const bootstrapDataJson = dataStart.substring(0, dataStart.indexOf(endDataTag));
      const bootstrapData = JSON.parse(bootstrapDataJson
        .substring(bootstrapDataJson.indexOf('>') + 1));
      const {
        csrftoken: {
          token,
        },
      } = bootstrapData;
      // Update value in both state management solutions
      // since its referenced from both depending on
      // the code path
      CsrfTokenActions.setToken(token);
      ReduxStoreStore.getState().reduxStore.dispatch(setCsrfToken(token));
    });
  }
}

export default new CsrfTokenActionCreator();
